import { render, staticRenderFns } from "./StudentIndexView.vue?vue&type=template&id=7bdc03af"
import script from "./StudentIndexView.vue?vue&type=script&lang=js"
export * from "./StudentIndexView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports